export default __webpack_public_path__ + "static/media/personalPath.2857e882.svg";